<template>
    <fragment>
        <div class="attachment_wrap">
            <div
                :id="uploadId"
            />
        </div>
        <div class="btn_wrap pt-5">
            <div class="btn_right">
                <a href="javascript:" type="button" class="btn_sm_white" @click="downloadSelectedFiles()">{{ $t('BUTTON.GLOBAL.DOWNLOAD.SELECTED') }}</a>
                <a href="javascript:" type="button" class="btn_sm_white" @click="download()">{{ $t('BUTTON.GLOBAL.DOWNLOAD.ALL') }}</a>
            </div>
        </div>
    </fragment>
</template>

<script>
import Vue                          from 'vue';
import { mapActions, mapGetters }   from 'vuex';
import _                            from 'lodash';
import $                            from 'jquery';
import axios                        from 'axios';
import store                        from '@/vuex/store';
import SDLLocale                    from '@/mixin/SDLLocale';
import { SDLUtil }                  from '@/utils';
import { EventBus }                 from '@/utils/EventBus';

import qs from 'query-string';

let urlBase         = `${SDLUtil.WEB_CONTEXT_PATH}/static/js/innorix/exam/`;  // location.href.substring(0, location.href.lastIndexOf("/") + 1);
//let apiBase       = "http://skp.samsungcsportal.com/basis/common/attachDownload.skp";
let cmnApiBase      = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
let mailApiBase     = `${SDLUtil.API_URL}/noauth/attachDownload.skp`;
let hhpApiBase      = `${SDLUtil.API_URL}/basis/anysvcmobile/findcontent/FindContentDownLoad.skp`;
let hhpSvcApiBase   = `${SDLUtil.API_URL}/basis/common/attachBulletinDownload.skp`;
let cmsApiBase      = `${SDLUtil.API_URL}/basis/common/cmsContents/cmsDownload.skp`;

const hhpSvcDownloadCountApi = `${SDLUtil.API_URL}/basis/common/attachBulletinDownloadCount.skp`; // POST
const commonDownloadCountApi = `${SDLUtil.API_URL}/basis/common/attachContentDownloadCount.skp`; // POST

const INNORIX_RESET_FILE_LIST = 'innorix-reload-file-list';

export default {
    name: 'InnorixDownload',
    props: {
        uploadId    : { required: true, type: String, default: 'fileControl' },
        serviceType : { default: 'common' },
        attachList  : {},
        encToken    : { type: String },
        fixWidth    : { default: 0 },
        fixHeight   : { default: 0 },
        seq         : { default: ""}, // Not fileAttachSeq. SEQ of content to track file download count.
    },
    data() {
        return {
            window        : { width: 0, height: 0 },
            transferMode  : 'download',
            isLoading     : false,
            innoJquery    : new Object(),   // innorix jQuery 객체선언
            control       : new Object(),   // 파일전송 컨트롤 객체선언
            downFileArr   : new Array(),    // 다운로드 목록 정보
            resetFileArr  : new Array(),    // 다운로드 목록 초기화 정보
            delFileArr    : new Array(),    // 삭제된 파일 정보
            removeFlag    : true,           // 삭제 이벤트 조건 플래그
        };
    },
    computed: {
        ...mapGetters({
            locale: 'getLocale',
            sessionId: 'getSessionId',
        }),
        getTransferMode() {
            return this.transferMode || 'download';
        }
    },
    created() {
        this.$log.info('＃ InnorixDownload.vue created');
        window.addEventListener('resize', this.handleInnorixResize);

        EventBus.$on(INNORIX_RESET_FILE_LIST, (item) => {
            if (item.uploadId === this.uploadId) {
                this.$log.info(INNORIX_RESET_FILE_LIST + ' MATCHED', item.uploadId);
                this.reloadFileList(item.fileList);

            } else {
                this.$log.info(INNORIX_RESET_FILE_LIST + ' NOT MATCHED', item.uploadId);
            }
        });
    },
    mounted() {
        this.$nextTick(() => {
            SDLUtil.showLoadingBar(true);
            SDLUtil.importJS(`${this.$CONTEXT}/static/js/innorix/innorix.js`)
                .then(() => {
                    SDLUtil.showLoadingBar(false);
                    // this.$log.info('＃ InnorixDownload.vue ATTACH LIST', this.attachList);
                    this.loadComplete(this.uploadId);
                    this.handleInnorixResize();
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    this.$log.error('＃ InnorixDownload.vue mounted error => '.err);
                });
        });
    },
    destroyed() {
        window.removeEventListener('resize', this.handleInnorixResize);
    },
    methods: {
        handleInnorixResize() {
            let wrap = document.getElementsByClassName('attachment_wrap')[0];
            this.window.width = this.fixWidth ? this.fixWidth : wrap.clientWidth - 25;
            this.window.height = this.fixHeight ? this.fixHeight : wrap.clientHeight - 25;
            this.setSize(this.window.width, 200);
        },
        loadComplete(uploadId) {
            this.$log.info('＃ InnorixDownload.vue loadComplete / isMobile:', SDLUtil.isMobile());
            this.innoJquery = innorix._load("innoJquery");
            this.control    = innorix.create({
                el: '#' + uploadId,
                progressTitle: 'SKP',
                transferMode: this.getTransferMode,
                isMobile: SDLUtil.isMobile(),
                showGraph: (this.serviceType == 'common') ? ( SDLUtil.isMobile() ? false : true) : false,
                useFuncBtn: true,
                useContextMenu: false,
                useDownloadAction: false,
                url: `${SDLUtil.API_URL}`,
                resumeDownloadType: 'numbering', // 중복파일처리정책 자동번호붙여 저장 | overwrite, relay, numbering, confirm
                // downloadSliceSize: 2097152, // 2MB
                downloadSliceSize: 10485760, // 10MB
                // downloadSliceSize: 2147483648, // 2GB
                // downloadSliceSize: 10737418240, // 10GB
	            downloadSessionCount: 10, // 다운로드 세션 갯수
                downloadType : "direct",
                useDb: false, //클라이언트 DB사용여부
                showGraph: false,
                transferStart: { upload: 'auto', download: 'auto' }, //전송자동시작 유무
                agent: ['common', 'hhpsvc', 'hhp', 'cms', 'mail'].includes(this.serviceType) ? true : false, // hhp mode 일 때 html5 모드로 사용?
                monitorServer: '', //MRT URL
                installUrl: `${SDLUtil.WEB_CONTEXT_PATH}/static/js/innorix/install/install.html`,
                retryCount : 1,
                retryDelay  : 1,
                maximumErrorCount  : 1
            });

            // 파일전송 컨트롤 로딩 완료
            this.control.on('loadComplete', (p) => {
                // 세션정보 저장
                this.control.setCookie("JSESSIONID=" + this.sessionId);
                // 다운로드 목록
                this.downFileArr = this.setAttachList(this.attachList);
                this.resetFileArr = this.downFileArr; // 다운로드 정보 초기화 정보 생성
                this.resetFileArr = this.resetFileArr.slice(0); // 배열 깊은 복사
                this.control.presetDownloadFiles(this.resetFileArr); // 다운로드 파일 추가
                this.$log.info('＃ InnorixDownload.vue control loadComplete.', this.downFileArr.length, this.resetFileArr.length);
            });

            // 파일 더블클릭 이벤트
            this.control.on('onDblClickRows', (p) => {
                this.onDblClickRows();
            });

            this.control.on('downloadStart', (p) => {
                this.$log.info('＃ InnorixDownload.vue control downloadStart.');
            });

            this.control.on('downloadComplete', (p) => {
                this.$log.info('＃ InnorixDownload.vue control downloadComplete.');
                if (this.serviceType === 'hhpsvc' && this.seq) {
                    this.increaseHhpDownloadCount(this.seq);
                } else if (this.serviceType === 'hhp') {
                    // do nothing. Usually from FindContent
                } else if (this.serviceType === 'mail') {

                } else {
                    this.increaseCommonDownloadCount(this.seq);
                }

                this.handleInnorixResize();
            });

            this.isLoading = true;
        },
        downloadHhpFile(downloadFiles, index) {
            if (downloadFiles.length <= index) return;
            const item = downloadFiles[index];
            SDLUtil.confirm({
                title: `File Download (${index+1}/${downloadFiles.length})`,
                msg: `Woud you like to download the following file?<br><strong>${item.printFileName}</strong><br>${item.fileSize} bytes`,
                okLabel: 'BUTTON.GLOBAL.DOWNLOAD',
                cancelLabel: 'Skip',
                onOkEvt: () => {
                    this.downloadHhpFile(downloadFiles, index + 1);
                    window.open(item.downloadUrl);
                },
                onCancelEvt: () => {
                    this.downloadHhpFile(downloadFiles, index + 1);
                }
            });
        },
        downloadHhpSelected(index) {
            const downloadFiles = this.control.getSelectedFiles();
            if (downloadFiles.length === 0) {
                SDLUtil.alert({
                    title: 'File Download',
                    msg: 'Please select files to download.',
                });
            } else {
                this.downloadHhpFile(downloadFiles, index);
            }
        },
        downloadHhpAll(index) {
            const downloadFiles = this.control.getDownloadFiles();
            if (downloadFiles.length === 0) {
                SDLUtil.alert({
                    title: 'Oops!',
                    msg: 'There is nothing to download!',
                });
            } else {
                this.downloadHhpFile(downloadFiles, index);
            }
        },
        downloadSelectedFiles() {
            // if (this.serviceType === 'hhpp') {
            //     this.downloadHhpSelected(0);

            // } else
            // if (this.serviceType === 'cms') {
            //     this.downloadHhpSelected(0);

            // } else {
                SDLUtil.showLoadingBar(true);
                this.control.setDownloadPath((res) => {
                    if(res.result == true) {
                        this.control.downloadSelectedFiles();
                    }
                });

                SDLUtil.showLoadingBar(false);
            // }

            this.handleInnorixResize();
        },
        download() {
            // if (this.serviceType === 'hhp') {
            //     this.downloadHhpAll(0);
            // } else {
                SDLUtil.showLoadingBar(true);
                this.control.setDownloadPath((res) => {
                    if(res.result == true) {
                        this.control.download();
                    }
                });
                SDLUtil.showLoadingBar(false);
            // }

            this.handleInnorixResize();
        },
        increaseHhpDownloadCount(seq) {
            return axios.post(hhpSvcDownloadCountApi+'?'+qs.stringify({seq}));
        },
        increaseCommonDownloadCount(seq) {
            return axios.post(commonDownloadCountApi+'?'+qs.stringify({seq}));
        },
        onDblClickRows() {
            if(!SDLUtil.isMobile()) {
                // 마지막 인덱스 오픈 
                this.control.downloadAndOpen();            
            } else {
                this.control.downloadSelectedFiles();    
            }

            this.handleInnorixResize();
        },
        setSize(width, height) {
            if(this.isLoading) this.control.setSize(width, height);
        },
        setAttachList(attachList = []) {
            Vue.$log.info('this.serviceType', this.serviceType);
            let downloadList = [];
            if(this.serviceType == 'common') {
                if(attachList.length > 0) {
                    for(let attach of attachList) {
                        let downloadUrl = cmnApiBase + "?attachFileSeq=" + attach.ENC_ATTCH_FILE_SEQ + "&encToken=" + attach.ENC_TOKEN;
                        this.$log.info('＃ InnorixDownload.vue AttachList download url => ', downloadUrl);
                        downloadList.push({
                            printFileName: attach.FILE_NM,
                            fileSize: attach.FILE_SIZE,
                            validate: true,
                            downloadUrl: downloadUrl /* + "," + attach.FILE_NM + "," + attach.FILE_SIZE*/
                        });
                    }
                }
            } else if(this.serviceType === 'hhpsvc') {
                if (attachList.length > 0) {
                    for (let attach of attachList) {
                        const params = {
                            attachFileSeq: attach.ENC_ATTCH_FILE_SEQ,
                            encToken: attach.ENC_TOKEN,
                            anysvc: 'Y',
                            seq: this.seq,
                            // encToken: this.encToken,
                        };

                        const downloadUrl = `${hhpSvcApiBase}?${qs.stringify(params)}`;
                        this.$log.info('＃ InnorixDownload.vue HHP AttachList download url => ', downloadUrl, attach);
                        this.$log.info('＃ InnorixDownload.vue HHP AttachList  => ', attach);
                        downloadList.push({
                            printFileName: attach.FILE_NM,
                            fileSize: attach.FILE_SIZE,
                            downloadUrl: downloadUrl,
                            validate: true,
                        });
                    }
                }
            } else if(this.serviceType === 'hhp') {
                if(attachList.length > 0) {
                    for (let attach of attachList) {
                        const params = {
                            VPATH: `${attach.VPATH}`,
                            TYPE: `${attach.TYPE}`,
                            CTTID: `${attach.CTTID}`,
                            CTTTYPE: `${attach.CTTTYPE}`,
                            NMMODEL: `${attach.NMMODEL}`,
                            COUNTRY_CD: `${attach.COUNTRY_CD}`,
                            CATEGORY: `${attach.CATEGORY}`,
                            BUYER: `${attach.BUYER}`,
                            encToken: this.encToken,
                        };

                        const downloadUrl = `${hhpApiBase}?${qs.stringify(params)}`;
                        this.$log.info('＃ InnorixDownload.vue HHP AttachList download url => ', downloadUrl);
                        downloadList.push({
                            printFileName: attach.FILENAME,
                            fileSize: attach.CTTFILESIZE,
                            downloadUrl: downloadUrl,
                            validate: true,
                        });
                    }
                }
            } else if(this.serviceType === 'cms') {
                if(attachList.length > 0) {
                    attachList.forEach(attach => {
                        let downloadUrl = '';
                        if (attach.downloadurl[0] === '/') {
                            downloadUrl = `${SDLUtil.API_URL}${attach.downloadurl}&encToken=${this.encToken}`;
                        } else {
                            downloadUrl = `${attach.downloadurl}`;

                        }
                        downloadList.push({
                            printFileName: attach.filename,
                            fileSize: attach.filesize,
                            downloadUrl: downloadUrl,
                            validate: true,
                        });

                    });
                }
            } else if (this.serviceType === 'mail') {
                if(attachList.length > 0) {
                    for(let attach of attachList) {
                        let downloadUrl = mailApiBase + "?attachFileSeq=" + attach.ATTCH_FILE_SEQ;
                        this.$log.info('＃ InnorixDownload.vue AttachList download url => ', downloadUrl);
                        downloadList.push({
                            printFileName: attach.FILE_NM,
                            fileSize: attach.FILE_SIZE,
                            validate: true,
                            downloadUrl: downloadUrl
                        });
                    }
                }
            }
            //"+criptorSEQ+"','"+attach.getString(i,"FILE_NM")+"','"+attach.getString(i,"FILE_SIZE")+"'],");
            return downloadList;
        },
        reloadFileList(fileList) {
            this.downFileArr = this.setAttachList(fileList);
            this.control.presetDownloadFiles(this.downFileArr);     // 다운로드 목록을 구성
            // 부모 컴포넌트로 데이터 전달
            this.emitParent();
        },
    },
    beforeDestroy() {
        EventBus.$off(INNORIX_RESET_FILE_LIST);

    },
};
</script>

<style scoped>
    .innorix_basic { border: none; }
</style>


// WEBPACK FOOTER //
// src/skpComponents/common/InnorixDownload.vue